import React from "react";
import { MainDialog } from "src/Components/Dialgos/MainDialog";
import { useTranslation } from "react-i18next";
import { indexStore } from "src/store/indexStore";
import CustomersForm from "./form/CustomersForm";

function EditCustomerModel(props) {
  const { t } = useTranslation();
  const { customer,updateCustomerFunction  } = indexStore();
  const handleSubmitEditCustomer = (values) => {
    const submitValues = {
      ...values,
      id: customer.id,
    };
    updateCustomerFunction(submitValues);
  };
  return (
    <MainDialog
      trigger={props.trigger}
      title={`${t("gloabl.edit")} ${t(`gloabl.customer`)}`}
    >
      <CustomersForm
        onSubmit={handleSubmitEditCustomer}
        editMode={true}
        datasource={customer}
      />
    </MainDialog>
  );
}

export default EditCustomerModel;
